import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class WaitListDriver extends AbstractModel {
  @autoserialize
  firstName: string;

  @autoserialize
  lastName: string;

  @autoserialize
  emailAddress: string;

  @autoserialize
  zipCode: string;

  @autoserialize
  phoneNumber: string;
}
